'use strict';

export default function routes($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/assistants', {
      template: require('./assistants.pug'),
      controller: 'AssistantsController',
      controllerAs: 'assistants',
    });
};




// WEBPACK FOOTER //
// ./client/app/manager/assistants/assistants.routes.ts